import { render, staticRenderFns } from "./LimitUserAccess.vue?vue&type=template&id=3c4727e4&scoped=true&"
import script from "./LimitUserAccess.vue?vue&type=script&lang=js&"
export * from "./LimitUserAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4727e4",
  null
  
)

export default component.exports